import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { forwardRef, inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { LanguageStoreHandlerService } from './language-store-handler.service';

export const ACCEPT_LANGUAGE_HEADER_INTERCEPTOR_PROVIDER = {
  provide: HTTP_INTERCEPTORS,
  useClass: forwardRef(() => AcceptLanguageInterceptor),
  multi: true,
};

@Injectable()
export class AcceptLanguageInterceptor implements HttpInterceptor {
  private languageService = inject(LanguageStoreHandlerService);
  private translateService = inject(TranslateService);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const language = this.translateService.currentLang || this.translateService.defaultLang;
    /** Do not override accept-language header if already exists. Used for translations/ endpoint
     * HttpClient changes all headers to lowercase on request
     */
    if (language && !request.headers.has('accept-language')) {
      request = request.clone({
        setHeaders: {
          'Accept-Language': `${language}`,
        },
      });
    }
    return next.handle(request);
  }
}
